var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board"},[_c('div',{staticClass:"board__inner"},[_c('div',{staticClass:"board__field"},[_c('Field')],1),_c('div',{staticClass:"board__players"},_vm._l((_vm.players),function(player){return _c('div',{key:player.key,staticClass:"board__player",class:{
          'board__player--n': player.position === 'n',
          'board__player--o': player.position === 'o',
          'board__player--s': player.position === 's',
          'board__player--w': player.position === 'w'
        }},[_c('Player',{attrs:{"player":player}})],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }